export default "__VITE_ASSET__B0Osne5U__"